const formatCreatedByLabel = (userData, userRn) => {
  const displayName = [userData?.firstName, userData?.lastName].filter(Boolean).join(' ');

  return displayName ? `${displayName} (${userRn})` : userRn;
};

const isUserRn = (value) => {
  return typeof value === 'string' && value.startsWith('RN:USER-V1-');
};

export {
  formatCreatedByLabel,
  isUserRn,
};
